const storeCookie = (key, value, expirationDate) => {
    const cookie = {
        [key]: value,
        "expires": expirationDate.toUTCString(),
        "path": "/"
    }

    const cookieString = Object.keys(cookie).map(key => `${key}=${cookie[key]}`).join("; ")
    document.cookie = cookieString
}

const readCookie = key => {
    const allCookieStrings = document.cookie.split(';').map(cookieString => cookieString.trim())
    const targetCookieString = allCookieStrings.filter(cookieString => cookieString.startsWith(key))[0]
    if (!targetCookieString) return null
    let [, ...cookieValue] = targetCookieString.split('=')
    cookieValue = cookieValue.join('=');
    return cookieValue
}

const deleteCookie = key => {
    const expiredDate = new Date()
    expiredDate.setSeconds(expiredDate.getSeconds() - 1)
    storeCookie(key, null, expiredDate)
}

export { deleteCookie, readCookie, storeCookie }